import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Doctor } from 'src/app/Models/doctor.model';
import { PatientBooking } from 'src/app/Models/patientbooking.model';
import { AppointmentService } from 'src/app/services/appointment.service';
import { BookedslotsService } from 'src/app/services/bookedslots.service';
import { DoctorService } from 'src/app/services/doctor.service';
import { HospitalService } from 'src/app/services/hospital.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-view-all-appointments',
  templateUrl: './view-all-appointments.component.html',
  styleUrls: ['./view-all-appointments.component.css'],
})
export class ViewAllAppointmentsComponent implements OnInit {
  displayedColumns: string[] = [
    'PatientId',
    'DoctorName',
    'DoctorSpecialization',
    'VisitDate',
    'VisitTime',
    'Message',
    'Status',
    'Detail',
    'Delete',
  ];

  doctor: Doctor[] = [];
  doctorList: Doctor[] = [];

  id = 0;
  ptAppointments: PatientBooking[] = [];

  filteredList;
  dataSource: MatTableDataSource<any>;
  helper = new JwtHelperService();

  myToken = window.localStorage.getItem('token');
  Frm: FormGroup;
  constructor(
    private doctorService: DoctorService,
    private route: ActivatedRoute,
    private router: Router,
    private appointmentService: AppointmentService,
    private hospitalService: HospitalService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    let decodedToken = this.helper.decodeToken(this.myToken);
    this.id = parseInt(decodedToken.nameid);

    // this.route.params.subscribe(res=>{
    //   this.id= res['id'];
    // })

    this.getDoctor(this.id);
    this.Frm = this.fb.group({
      DoctorId: [''],
    });

    this.getAppt();
  }

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  get DoctorId() {
    return this.Frm.get('DoctorId');
  }

  getDoctor(id) {
    this.hospitalService.getDoctors(id).subscribe((res) => {
      this.doctor = res.Doctors;
    });
  }
  getAppt() {
    this.doctorService
      .getDoctorBooking(this.DoctorId.value)
      .subscribe((res) => {
        this.dataSource = new MatTableDataSource(res.PatientBookings);
        this.dataSource.paginator = this.paginator;
        this.filteredList = res.PatientBookings;

        this.ptAppointments = res.PatientBookings;
      });
  }

  search(searchValue) {
    // console.log(searchValue);
    if (searchValue.value != null) {
      this.filteredList = this.ptAppointments.filter((x) =>
        x.VisitDate.toLowerCase().includes(searchValue.value.toLowerCase())
      );
    }
  }
  delete(id) {
    this.appointmentService.deletePatientBooking(id).subscribe((res) => {
      this.getAppt();
    });
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
}
